const MuiAppBar = {
  styleOverrides: {
    colorPrimary: {
      // background: 'transparent',
    },
  },
};

export default MuiAppBar;
